<template>
  <div class="picker-wrap">
    <div
      class="title"
      :class="[{ 'is-must': isMust }, { 'is-need-line': isNeedLine }]"
    >
      {{ title }}
    </div>
    <div @click="showPickerPopup" class="select-block">
      <div v-if="selectValue.value !== null && selectValue.value !== undefined">
        {{ selectValue[$attrs.valueKey] }}
      </div>
      <div v-else class="placeholder">{{ placeholder }}</div>
      <van-icon class="arrow-icon" name="arrow" v-if="!disabled" />
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="data"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  getCurrentInstance
} from "@vue/composition-api";

export default defineComponent({
  name: "PickerCom",
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      // 是否禁用
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    initValue: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    title: {
      type: String,
      default: ""
    },
    isMust: {
      type: Boolean,
      default: false
    },
    isNeedLine: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      showPicker: false,
      columns: [],
      selectValue: {}
    });
    const onConfirm = value => {
      console.log("-------", value);
      state.selectValue = value;
      state.showPicker = false;
      proxy.$emit("input", [value.value]);
    };

    onMounted(() => {
      if (props.initValue) {
        // 初始值特殊处理
        state.selectValue = {
          name: props.initValue[0],
          value: props.initValue[0]
        };
      }
    });
    const showPickerPopup = () => {
      if (props.disabled) return;
      state.showPicker = true;
    };
    return {
      ...toRefs(state),
      onConfirm,
      showPickerPopup
    };
  }
});
</script>
<style lang="less" scoped>
.picker-wrap {
  padding: 28px 0;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #020f22;
  font-weight: 400;
  position: relative;
  padding-right: 40px;
  .title {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #7e8388;
    line-height: 16px;
    font-weight: 400;
    margin-bottom: 16px;
  }
  .placeholder {
    color: #a4abb0;
  }
  .is-must {
    &::after {
      content: "*";
      color: #ff4d4f !important;
    }
  }
  .is-need-line {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #ebedf0;
      transform: rotateY(0.5);
    }
  }
  .arrow-icon {
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pickerCom.vue